import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Errors from 'components/shared/Errors';
import Success from 'components/shared/Success';
import Main from 'components/templates/Main';
import Receipt from '../components/Receipt';
import * as actionCreators from '../redux/actionCreators';
import * as selectors from '../redux/selectors';

class ReceiptContainer extends React.Component {
  componentDidMount() {
    const { match, fetchPaymentOrderRequest } = this.props;

    const { orderId } = match.params;

    fetchPaymentOrderRequest({ orderId });
  }

  componentWillUnmount() {
    this.props.fetchPaymentOrderSuccess({ order: {} });
  }

  render() {
    const { error, isLoading, order, success } = this.props;

    return (
      <Main
        title={
          <>
            <FormattedMessage id="Receipt" defaultMessage="Receipt" /> #{order.id}
          </>
        }
      >
        <Receipt isLoading={isLoading} order={order} />
        <Success success={success} />
        <Errors errors={error} />
      </Main>
    );
  }
}

ReceiptContainer.propTypes = {
  error: PropTypes.shape({}),
  isLoading: PropTypes.bool,
  match: PropTypes.shape({
    params: PropTypes.shape({
      cottageId: PropTypes.string,
      orderId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  order: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  success: PropTypes.shape({}),

  fetchPaymentOrderRequest: PropTypes.func.isRequired,
  fetchPaymentOrderSuccess: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  error: selectors.error(state),
  isLoading: selectors.isLoading(state),
  order: selectors.order(state),
  success: selectors.success(state),
});

const mapDispatchToProp = {
  fetchPaymentOrderRequest: actionCreators.fetchPaymentOrderRequest,
  fetchPaymentOrderSuccess: actionCreators.fetchPaymentOrderSuccess,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProp)(ReceiptContainer));
